import { render, staticRenderFns } from "./DetailPassword.vue?vue&type=template&id=259d2063&"
import script from "./DetailPassword.vue?vue&type=script&lang=js&"
export * from "./DetailPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports